// Module-level handle on the Redux store so non-React modules (toast helpers,
// api utils) can read auth state without threading it through every call site.
// Set once from createStore; consumers must tolerate it being unset.
let store: any = null;

export const setStore = (nextStore: any): void => {
  store = nextStore;
};

export const getStore = (): any => store;

export const getStoreState = (): any => (store ? store.getState() : null);
